import type { ILineContractor } from '../../../models/line-contractor.model';

export class LineContractorApiModel {
  public static mapToBusinessModel(apiModel: LineContractorApiModel): ILineContractor | undefined {
    if (!apiModel) {
      return undefined;
    }
    return {
      name: apiModel.name,
      comment: apiModel.comment,
      emailAddress: apiModel.emailAddress,
      phoneHours: apiModel.phoneHours,
      telephoneNumber: apiModel.telephoneNumber,
      website: apiModel.website,
    };
  }

  public name!: string;
  public website!: string;
  public telephoneNumber!: string;
  public emailAddress!: string;
  public phoneHours!: string;
  public comment!: string;
}

